import { render, staticRenderFns } from "./InspectionFormSectionFieldFormThreshold.vue?vue&type=template&id=231620b1"
import script from "./InspectionFormSectionFieldFormThreshold.vue?vue&type=script&lang=js"
export * from "./InspectionFormSectionFieldFormThreshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports